import React from "react";
import { makeStyles, useTheme, useMediaQuery, Box } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import TitlePage from "./../../../common/TitlePage";
import Carousel from "react-elastic-carousel";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    overflow: "hidden",
  },
  root: {
    width: 660,
    margin: "auto",
    textAlign: "center",
    paddingBottom: 100,
    [theme.breakpoints.down("680")]: {
      width: "95%",
      paddingBottom: 60,
    },
  },
  content: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: 60,
    [theme.breakpoints.down("768")]: {
      marginTop: 20,
    },
  },
  box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "30px 10px",
  },
  circle: {
    width: 78,
    height: 78,
    borderRadius: "50%",
    border: `1px solid #0B1742`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
  },
  borderWhite: {
    width: 71,
    height: 71,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "3px solid white",
  },
  icon: {
    width: 37,
    height: 36,
  },
  fontSize1: {
    fontSize: 18,
    margin: "20px 0",
  },
  btn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "171px",
    height: "38px",
    border: "1px solid #d1d1d1",
    borderRadius: "20px",
    margin: "0 auto",
  },
  mobileWrap: {
    display: "none",
    padding: "0 16px",
    marginTop: 20,
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  mobileTitle: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 16,
  },
  carouselWrap: {
    "& .rec-carousel": {
      maxWidth: "100%",
    },
    "& .rec-slide": {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

export default function SystemTrades() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <TitlePage position="bottomCenter">دستور العمل ها</TitlePage>

        {/* دسکتاپ */}
        {!isMobile && (
          <Box className={classes.content}>
            {data.map((item, ind) => (
              <Box key={ind} className={classes.box}>
                <a href={item.src2} target="_blank" download>
                  <div className={classes.circle}>
                    <div className={classes.borderWhite}>
                      <svg className={classes.icon}>
                        <use xlinkHref={`/sprit.svg#train`} />
                      </svg>
                    </div>
                  </div>
                  <p className={classes.fontSize1}>{item.title}</p>
                </a>
                <a
                  href={item.src1}
                  target="_blank"
                  download
                  className={classes.btn}
                >
                  {item.link}
                </a>
              </Box>
            ))}
          </Box>
        )}

        {/* موبایل: اسلایدر */}
        {isMobile && (
          <div className={classes.mobileWrap}>
            <div className={classes.carouselWrap}>
              <Carousel
                breakPoints={[{ width: 1, itemsToShow: 1 }]}
                enableAutoPlay
                autoPlaySpeed={3000}
                renderArrow={() => <span style={{ display: "none" }} />}
                renderPagination={() => <span style={{ display: "none" }} />}
                isRTL
              >
                {data.map((item, ind) => (
                  <Box key={ind} className={classes.box}>
                    <a href={item.src2} target="_blank" download>
                      <div className={classes.circle}>
                        <div className={classes.borderWhite}>
                          <svg className={classes.icon}>
                            <use xlinkHref={`/sprit.svg#train`} />
                          </svg>
                        </div>
                      </div>
                      <p className={classes.fontSize1}>{item.title}</p>
                    </a>

                    <a
                      href={item.src1}
                      target="_blank"
                      download
                      className={classes.btn}
                      style={{ marginTop: 10 }}
                    >
                      {item.link}
                    </a>
                  </Box>
                ))}
              </Carousel>
            </div>
          </div>
        )}
      </div>

      <Hidden smDown>
        <Box className={classes.background}>
          <img src="/assets/images/fade-logo.png" alt="background-pouyan" />
        </Box>
      </Hidden>
    </div>
  );
}

const data = [
  {
    title: "دستورالعمل اجرایی معاملات بر خط",
    link: "دریافت",
    src1: "/assets/file/دستورالعمل اجرایی معاملات برخط.pdf",
    src2: "/assets/file/دستورالعمل اجرایی معاملات برخط.pdf",
  },
  {
    title: "دستورالعمل رسیدگی به تخلفات در بازار سرمایه",
    link: "دریافت",
    src1: "/assets/file/دستورالعمل رسيدگي به تخلفات در بازار سرمايه.pdf",
    src2: "/assets/file/دستورالعمل رسيدگي به تخلفات در بازار سرمايه.pdf",
  },
  {
    title: "روند ثبت نام",
    link: "دریافت",
    src1: "/assets/file/system/روند-ثبت نام.pdf",
    src2: "/assets/file/system/روند-ثبت نام.pdf",
  },
  {
    title: "محدودیت ماده 10",
    link: "دریافت",
    src1: "/assets/file/system/محدودیت-ماده-10.pdf",
    src2: "/assets/file/system/محدودیت-ماده-10.pdf",
  },
  {
    title: "مخاطرات",
    link: "دریافت",
    src1: "/assets/file/system/مخاطرات.pdf",
    src2: "/assets/file/system/مخاطرات.pdf",
  },
  {
    title: "معاملات بورس",
    link: "دریافت",
    src1: "/assets/file/system/معاملات-بورس.pdf",
    src2: "/assets/file/system/معاملات-بورس.pdf",
  },
  {
    title: "معاملات فرابورس",
    link: "دریافت",
    src1: "/assets/file/system/معاملات-فرابورس.pdf",
    src2: "/assets/file/system/معاملات-فرابورس.pdf",
  },
];
